/** Bookmark icon colors keyed by API `color` field (0–4). */
export const WATCHLIST_BOOKMARK_COLORS = [
  "#1E40AF",
  "#DC2626",
  "#16A34A",
  "#7C3AED",
  "#EA580C",
];

export const WATCHLIST_BOOKMARK_PALETTE = WATCHLIST_BOOKMARK_COLORS.map((value, index) => ({
  id: String(index),
  value,
}));

export const getWatchlistBookmarkColor = (colorIndex) => {
  const index = Number(colorIndex);
  if (Number.isInteger(index) && index >= 0 && index < WATCHLIST_BOOKMARK_COLORS.length) {
    return WATCHLIST_BOOKMARK_COLORS[index];
  }
  return WATCHLIST_BOOKMARK_COLORS[0];
};

const formatPrice = (value) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return "--";
  return num.toLocaleString("en-IN", { maximumFractionDigits: 2 });
};

const formatChangePercent = (value) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return "0";
  return Math.abs(num).toLocaleString("en-IN", { maximumFractionDigits: 2 });
};

export const buildWatchlistPriceItems = (response = {}) => {
  const rows = Array.isArray(response?.data) ? response.data : [];

  return rows.map((item, index) => {
    const changeIsPositive = Number(item.net_change) >= 0;

    return {
      id: `${item.exchange || "NA"}-${item.tradingsymbol || index}-${index}`,
      tradingsymbol: item.tradingsymbol,
      exchangeTradingSymbol: item.exchange_trading_symbol || item.tradingsymbol,
      exchange: item.exchange,
      name: item.tradingsymbol || "--",
      date: item.exchange || "",
      lastPrice: formatPrice(item.last_price),
      change: formatChangePercent(item.pct_change),
      changeIsPositive,
      colorIndex: Number.isFinite(Number(item.color)) ? Number(item.color) : 0,
      barColor: getWatchlistBookmarkColor(item.color),
      lastTradeTime: item.last_trade_time,
      showActionButtons: true,
    };
  });
};
